import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import {formatDate} from '@angular/common';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import swal from 'sweetalert2';
import { DecisionModel } from 'src/app/models/DecisionModel';
import { DecisionService } from 'src/app/services/DecisionService';
import { CompanyModel } from 'src/app/models/CompanyModel';
import { CompanyService } from 'src/app/services/CompanyService';
import { CurrentMedicationModel } from 'src/app/models/CurrentMedicationModel';
import { ItemsService } from 'src/app/services/ItemsService';
import { ItemsModel } from 'src/app/models/ItemsModel';
import { UnitsService } from 'src/app/services/UnitsService';
import { UnitsModel } from 'src/app/models/UnitsModel';
import { CurrentMedicationService } from 'src/app/services/CurrentMedicationService';
import { InvestgationReqMode, ScanReqModel } from 'src/app/models/InvestgationReqMode';
import { InvestgationReqService } from 'src/app/services/InvestgationReqService';
import { Router } from '@angular/router';
import { ReportdialogComponent } from '../reportdialog/reportdialog.component';
import { TreatmentGroupSearchComponent } from '../treatment-group-search/treatment-group-search.component';
import { TreatmentGroupHDModel } from 'src/app/models/TreatmentGroupHDModel';
import { TreatmentGroupHDService } from 'src/app/services/TreatmentGroupHDService';
import { TreatmentGroupDetService } from 'src/app/services/TreatmentGroupDetServic';
import { TreatmentGroupHDDetModel } from 'src/app/models/TreatmentGroupHDDetModel';

@Component({
  selector: 'app-decision-entry',
  templateUrl: './decision-entry.component.html',
  styleUrls: ['./decision-entry.component.css']
})
export class DecisionEntryComponent implements OnInit {

patientname = '';

  patientcode = '' ;
  decdate =formatDate(new Date(), 'yyyy-MM-dd', 'en');
  OriginalDate  =formatDate(new Date(), 'yyyy-MM-dd', 'en');
  declocation = '' ;
  decnotes = '' ;
  userid = '' ;
  username = '' ;
  dectime  =formatDate(new Date(), 'HH:mm', 'en');
  ////===================== Current Medication ====================
  cmdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  drugref = '' ;
  drugname = '' ;
  dose = '' ;
  uom = '' ;
  route = '' ;
  duration = '' ;
  gencomplaint = '' ;
  frequancy = '' ;
  cmdate1 = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  cmsource = '' ;
  cmdoctor = '' ;
  compcode = '' ;

  tgcode = '';
  tgname = '';

  modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  ittname = '' ;
  unname = '' ;
  companyList: CompanyModel[] = [];
  itemsList2 : ItemsModel[]=[];
  unitsList :UnitsModel []=[];
  currentmedication : CurrentMedicationModel[]=[];
  investgationreq : InvestgationReqMode[]=[];
  userrecordid = '';
  userrecordname = '';
  DrugTreatmentGroupDet: TreatmentGroupHDDetModel[] = [];
  DrugGroup: TreatmentGroupHDDetModel[] = [];

  invdate = '' ;
  invdescription = '' ;
  invnotes = '' ;
  modeficationdate = '' ;
  scandescription = '';
  scannotes = '';
  decnotestext = '' ;
editorConfigNoToolbar = {
  editable: true,
  spellcheck: true,
  showToolbar: true,  // 🚫 This hides the toolbar
  height: '150px',
  frameElement:true,
  minHeight: '0',
  placeholder: '',
  translate: 'yes',
  defaultParagraphSeparator: '',
  defaultFontName: '',

  toolbarHiddenButtons: []
};
  @Output() submitClicked = new EventEmitter<any>();

  maxCharsPerLine: number = 60; // Max characters per line

  constructor(public decision:DecisionModel,
    public dialogRef: MatDialogRef<DecisionEntryComponent>,
    public decisionservice : DecisionService,
    public itemsService :ItemsService,
    public storage: LocalStorageService,
    public companyService : CompanyService,
    public unitsService : UnitsService,
    public cmedicationService : CurrentMedicationService,
    public cmedication : CurrentMedicationModel,
    public invistgationrepService : InvestgationReqService,
    public invistgationrep: InvestgationReqMode,
     public TreatmentGroupHDSelectedData: TreatmentGroupHDModel,
     public TreatmentGroupHDService : TreatmentGroupHDService,
     public TreatmentGroupDetService : TreatmentGroupDetService,
    public scanrep: ScanReqModel,
    public route1 : Router,
    private dialogref: MatDialog,

    @Inject(MAT_DIALOG_DATA) public data :any,)
    {
        this.patientcode = data.patintcode;
        this.patientname = this.storage.retrieve('stgPatientName');
        this.decdate =   formatDate(data.docdate, 'yyyy-MM-dd', 'en');
        this.decnotes = data.decnotes;
        this.OriginalDate =  formatDate(data.docdate, 'yyyy-MM-dd', 'en');
            // if (this.storage.retrieve('stgGroup') == '8'){
            //   this.userid = data.useridid
            // }
            // else
            // {
            // this.userid = this.storage.retrieve('stgUserId')
            // };
            this.userrecordid = data.userrecordid;
            this.userid = data.userid;
            
            this.username = data.username;
            this.userrecordname = data.userrecordname;

    }

  ngOnInit(): void {

    this.declocation = this.storage.retrieve('stgLocation');
    this. retriveCompanyLookupTop();
    this.retriveItems();
    this.retriveUnitsLookupTop();
    this.RetriveData();
    this.retriveCMedication();
    this.retriveInvistgationRep();
    this.retriveScanRep();

  }
    retriveCompanyLookupTop() {
      this.companyService.getLocationLookupTop('1').subscribe((data: CompanyModel[]) => {
          for (let i = 0; i < data.length; i++) {
            this.companyList[i] = data[i];
          }

        });
    }
    updatePlainText() {
      const tempElement = document.createElement('div');
      tempElement.innerHTML = this.decnotes || '';
      this.decnotestext = tempElement.textContent || '';
    }
  retriveItems(){
        this.itemsService.getItemsLookupTop(this.storage.retrieve('stgcompCode')).subscribe((data: ItemsModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.itemsList2[i] = data[i];
        }

      })
    }
    retriveUnitsLookupTop() {
      this.unitsService.getUnitsLookupTop(this.storage.retrieve('stgcompCode'))
        .subscribe((data: UnitsModel[]) => {
          for (let i = 0; i < data.length; i++) {
            this.unitsList[i] = data[i];
          }

        });
    }
    SelectCurrent(cur: CurrentMedicationModel) {

      this.drugref = cur.drugref;
      this.drugname = cur.drugname ;
      this.cmdate = cur.cmdate;
      this.dose = cur.dose;
      this.uom = cur.uom ;
      this.route = cur.route ;
      this.duration = cur.duration ;
      this.gencomplaint = cur.gencomplaint ;
      this.frequancy = cur.frequancy ;
      this.ittname = cur.ittname ;
      this.unname = cur.unname ;

      this.submitClicked.emit(this.cmedication);

    }
    submitCMedication() {
      if (this.patientcode == null || this.patientcode == '') { return;}
      this.cmedication.patientcode = this.patientcode;

      this.cmedication.cmdate = formatDate(this.decdate, 'yyyy-MM-dd', 'en');
      this.cmedication.drugref = this.drugref ;
      this.cmedication.drugname = this.drugname ;
      this.cmedication.dose =this.dose ;
      this.cmedication.uom = this.uom;
      this.cmedication.route = this.route ;
      this.cmedication.duration = this.duration ;
      this.cmedication.gencomplaint = this.gencomplaint ;
      this.cmedication.frequancy = this.frequancy ;
      this.cmedication.cmdate1 = formatDate(this.cmdate1, 'yyyy-MM-dd', 'en');
      this.cmedication.cmsource = 'Home Medication' ;

      this.cmedication.cmdoctor = this.storage.retrieve('stguserId'); ;

      this.cmedication.userid = this.storage.retrieve('stguserId');
      this.cmedication.modifieddate = formatDate(new Date(),'yyyy-MM-dd','en'  );
      this.cmedication.compcode = this.storage.retrieve('stgcompCode');

      this.cmedicationService.AddCurrentMedication(this.cmedication).subscribe(
        (data) => {
          this.retriveCMedication();
          this.NewDataCurrentMedication();
        },
        (error) => {
          alert(error);
        }
      );
    }
    submitInvestgationRep() {
      if (this.patientcode == null || this.patientcode == '') {
        return;
      }
      this.invistgationrep.patientcode = this.patientcode;

      this.invistgationrep.invdate = formatDate(this.decdate, 'yyyy-MM-dd', 'en');
      this.invistgationrep.invdescription = this.invdescription ;
      this.invistgationrep.invnotes = this.invnotes ;
      this.invistgationrep.userid = this.storage.retrieve('stguserId');
      this.invistgationrep.modeficationdate = formatDate(new Date(),'yyyy-MM-dd','en'  );
      this.invistgationrep.compcode = this.storage.retrieve('stgcompCode');
      this.invistgationrepService.AddInvestgationReq(this.invistgationrep).subscribe(
        (data) => {
          this.submitSccanRep();
          this.retriveCMedication();
          this.NewDataCurrentMedication();
        },
        (error) => {
          alert(error);
        }
      );

    }
    submitSccanRep() {
      if (this.scandescription == null || this.scandescription == '') {
        return;
      }
      this.scanrep.patientcode = this.patientcode.trim();
      this.scanrep.scandate = formatDate(this.decdate, 'yyyy-MM-dd', 'en');
      this.scanrep.scandescription = this.scandescription ;
      this.scanrep.scannotes = this.scandescription ;
      this.scanrep.userid = this.storage.retrieve('stguserId');
      this.scanrep.modeficationdate = formatDate(new Date(),'yyyy-MM-dd','en'  );
      this.scanrep.compcode = this.storage.retrieve('stgcompCode');
      this.invistgationrepService.AddScanReq(this.scanrep).subscribe(
        (data) => {

        },
        (error) => {
          alert(error);
        }
      );
    }
    retriveScanRep(){

      this.invistgationrepService.GetScanReq(this.patientcode,this.decdate)
        .subscribe((data: ScanReqModel) => {
            this.scandescription = data.scandescription;
            this.scannotes = data.scannotes;

        });

    }
    retriveCMedication()
  {
    this.currentmedication = [];
    this.cmedicationService.getHomeMedication(this.patientcode,this.decdate ,'Home Medication',this.storage.retrieve('stgcompCode'))
      .subscribe((data: CurrentMedicationModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.currentmedication[i] = data[i];
        }

        //this.NewDataCurrentMedication();
      });

    }
    retriveInvistgationRep()
    {

      this.invistgationrepService.GetInvestgationReq(this.patientcode,this.decdate)
        .subscribe((data: InvestgationReqMode) => {
            this.invdescription = data.invdescription;
            this.invnotes = data.invnotes;

        });

      }
    NewDataCurrentMedication(){
      this.drugref = '' ;
      this.drugname = '' ;
      this.dose = '' ;
      this.uom = '' ;
      this.route = '' ;
      this.duration = '' ;
      this.gencomplaint = '' ;
      this.frequancy = '' ;
      this.ittname = '' ;
      this.unname = '' ;

    }
    delCurrentMedication_Line() {
      this.cmedicationService.delCurrentMedication(this.patientcode,this.drugref,this.storage.retrieve('stgcompCode')).subscribe((data: CurrentMedicationModel) => {
            this.retriveCMedication();
            this.NewDataCurrentMedication();
        });
    }

    limitLineLength() {
      const lines = this.decnotes.split("\n"); // Respect manual line breaks
      const formattedLines: string[] = [];

      for (let line of lines) {
        while (line.length > this.maxCharsPerLine) {
          let breakpoint = this.maxCharsPerLine;
          // Look for the last space before maxCharsPerLine to avoid breaking a word
          const lastSpace = line.lastIndexOf(" ", this.maxCharsPerLine);
          if (lastSpace > -1) {
            breakpoint = lastSpace;
          }
          // Push line up to the breakpoint
          formattedLines.push(line.substring(0, breakpoint).trim());
          // Trim and keep the rest of the line
           line = line.substring(breakpoint).trim();
        }
        formattedLines.push(line);
      }

      this.decnotes = formattedLines.join("\n");
    }

    RetriveData(){
      const  user =  this.storage.retrieve('stgUserId')

      this.decisionservice.getDecision(this.patientcode, this.decdate,this.userrecordid).subscribe({
        next: (data: DecisionModel) => {
          this.declocation = data.declocation;
          this.decdate =formatDate(data.decdate, 'yyyy-MM-dd', 'en');
          this.decnotes = data.decnotes;
          this.userid = data.userid;
          this.dectime = formatDate(data.dectime, 'hh:mm aa', 'en');
        },
        error: (error) => {
          // Handle any actual errors here, if needed.  For example:
          console.error("Error fetching nurse assessment:", error);
          // You might also want to display an error message to the user.
        },
        complete: () => {
          // This block executes after a successful completion (even if data is null/undefined).
            if (!this.declocation) {  // Check if visitlocation is undefined or null.  Could also check for an empty string "" if that's a possibility.
              this.declocation = this.storage.retrieve('stgLocation');
                this.decdate = formatDate(this.OriginalDate, 'yyyy-MM-dd', 'en');
            }
        }
      });
    }
    Save_Data(){
      this.dectime  =formatDate(new Date(), 'HH:mm', 'en');
      const str1 = formatDate(this.decdate, 'yyyy-MM-dd', 'en') + 'T' + this.dectime+':00.000Z';

      this.decision.patientcode= this.patientcode;
      this.decision.decdate= this.decdate;
      this.decision.declocation= this.declocation;
      this.decision.decnotes= this.decnotes;
      debugger;
      if (this.storage.retrieve('stgGroup') == '8'){
        this.decision.userid =  this.userrecordid;
        this.decision.username= this.userrecordname;
      }
      else
      {
        this.decision.userid =  this.storage.retrieve('stgUserId');
        this.decision.username= this.username;
      };

      //this.decision.userid= this.storage.retrieve('stguserId');
     // this.decision.username= this.storage.retrieve('stgusername');
      this.decision.dectime= str1;
      this.decisionservice.AddDecision(this.decision).subscribe(data => {
      this.submitInvestgationRep();
      this.mesgSave();

      this.dialogRef.close();
        },
          error => { alert(error); }
        );

    }

    Print_PrescriptionDialog(){
      this.storage.store('stgPar', this.patientcode);
      this.storage.store('stgDate', this.decdate);
      this.storage.store('stgSource', 'Home Medication');


    ////******************************** */
        const dialogRef = this.dialogref.open(ReportdialogComponent,
          {
            data: {
              reportUrl: 'CocReports/Prescription',

            },
            width: '40vw',
            height: '90vw',
          });
        dialogRef.afterClosed().subscribe(result => {
        });

        const dialogSubmitSubscription =
          dialogRef.componentInstance.submitClicked.subscribe(result => {
            dialogSubmitSubscription.unsubscribe();
          });
  }
  Print_ReqLabDialog(){
    this.storage.store('stgPar', this.patientcode.trim());
    this.storage.store('stgDate', this.decdate);
    ////******************************** */
    const dialogRef = this.dialogref.open(ReportdialogComponent,
      {
        data: {
          reportUrl: 'CocReports/ReqLab',

        },
        width: '40vw',
        height: '90vw',
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        dialogSubmitSubscription.unsubscribe();
      });
  }
  Print_ReqScanDialog(){
    this.storage.store('stgPar', this.patientcode.trim());
    this.storage.store('stgDate', this.decdate);
    const dialogRef = this.dialogref.open(ReportdialogComponent,
      {
        data: {
          reportUrl: 'CocReports/ReqScan',

        },
        width: '40vw',
        height: '90vw',
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        dialogSubmitSubscription.unsubscribe();
      });
  }
    mesgSave() {
      swal({
      title: 'Your work has been saved',

      type: 'success',
      showConfirmButton: false,

      timer: 1500
      });
    }
  Exit_Data(){
    this.dialogRef.close();
  }
  //////////************************* Select from Treatment Group  ***************************************/
  TreatmentGroupSearch(){
  const dialogRef = this.dialogref.open(TreatmentGroupSearchComponent,
      {
        data: {
          dataKey: this.TreatmentGroupHDSelectedData
        }
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.tgcode = result.tgcode;
        this.tgname = result.tgname;
         this.retriveTreatmentGroupDetTop()
        dialogSubmitSubscription.unsubscribe();
      });

  }
  retriveTreatmentGroupHD(){

    this.TreatmentGroupHDService.getTreatmentGroupHD(this.tgcode, this.storage.retrieve('stgcompCode')).subscribe((data: TreatmentGroupHDModel) => {
      this.tgname = data.tgname;
      this.retriveTreatmentGroupDetTop();

    });
  }
  ////////////**************** Write treatment group to the current Medication  ***************************/
  retriveTreatmentGroupDetTop() {
      this.DrugGroup = [];
      this.TreatmentGroupDetService.GetTreatmentGroupDet(this.tgcode, this.storage.retrieve('stgcompCode')).subscribe((data: TreatmentGroupHDDetModel[]) => {
        for (let i = 0; i < data.length; i++) {

          this.cmedication.patientcode = this.patientcode;
          this.cmedication.cmdate = formatDate(this.decdate, 'yyyy-MM-dd', 'en');
          this.cmedication.drugref = data[i].tgdetitcode ;
          this.cmedication.drugname = data[i].tgdetitname;
          this.cmedication.dose = data[i].tgdetdose ;
          this.cmedication.uom = data[i].tgdetqty;
          this.cmedication.route = data[i].tgdetrote ;
          this.cmedication.duration = data[i].tgdetduration;
          this.cmedication.gencomplaint =  '' ;
          this.cmedication.frequancy = data[i].tgdetnotes;
          this.cmedication.cmdate1 = formatDate(this.cmdate, 'yyyy-MM-dd', 'en');
          this.cmedication.cmsource = 'Home Medication' ;
          this.cmedication.cmdoctor = this.storage.retrieve('stguserId'); ;
          this.cmedication.userid = this.storage.retrieve('stguserId');
          this.cmedication.modifieddate = formatDate(new Date(),'yyyy-MM-dd','en'  );
          this.cmedication.compcode = this.storage.retrieve('stgcompCode');

          this.cmedicationService.AddCurrentMedication(this.cmedication).subscribe(
            (data) => {
              this.retriveCMedication();
              this.NewDataCurrentMedication();
            },
            (error) => {
              alert(error);
            }
          );
            }


      });

    }
}
